import { render } from "./PointAdjustmentDialog.vue?vue&type=template&id=f0aea244&scoped=true"
import script from "./PointAdjustmentDialog.vue?vue&type=script&lang=js"
export * from "./PointAdjustmentDialog.vue?vue&type=script&lang=js"

import "./PointAdjustmentDialog.vue?vue&type=style&index=0&id=f0aea244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0aea244"]])

export default __exports__